import { AanZetSearchIcon } from "../AanZet/Features/AanZetSearchIcon";
import { SearchIcon } from "./components/SearchIcon";
import { getConfig } from "./features/featureSwitch";
const defaultConfig = {
    defaultLinkClass: '',
    privacyStatementUrl: '/privacyverklaring',
    ui: {
        arrowIconId: '#icon--arrow',
        pagination: {
            linkClass: 'secondary',
            nextIconId: '#icon--arrow',
            previousIconId: '#icon--arrow'
        },
        SearchIcon: SearchIcon
    }
};
const configs = {
    vbp: {
        ...defaultConfig
    },
    aanzet: {
        ...defaultConfig,
        defaultLinkClass: 'link',
        ui: {
            arrowIconId: '#icon--arrow',
            pagination: {
                linkClass: 'primary'
            },
            SearchIcon: AanZetSearchIcon
        }
    },
    bkw: {
        ...defaultConfig
    },
    dnb: {
        ...defaultConfig,
        privacyStatementUrl: '/privacy',
        ui: {
            arrowIconId: '#icon--chevron-right-large',
            pagination: {
                linkClass: 'primary',
                nextIconId: "#icon--chevron-right-large",
                previousIconId: "#icon--chevron-left-large"
            },
            SearchIcon: SearchIcon
        }
    },
    flevo: {
        ...defaultConfig,
        privacyStatementUrl: '/privacy'
    },
    rdam: {
        ...defaultConfig,
        defaultLinkClass: 'link'
    },
    twente: {
        ...defaultConfig
    }
};
export const config = getConfig(configs);
